import { decodeSkillsStatus } from 'models/Candidate/SkillsSession';
import { ServerApi } from 'modules/api/server-api';

export const fetchCandidateSkillsStatus = (api: ServerApi) => async () => {
  const response = await api.get('/v3/candidate/skills/session-status');
  return decodeSkillsStatus(response.data);
};
